import React, { useState, useReducer, useEffect, ChangeEventHandler, ChangeEvent, SyntheticEvent, KeyboardEvent, createContext } from "react";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Slider from '@mui/material/Slider';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Icon from '@mui/material/Icon';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import WifiIcon from '@mui/icons-material/Wifi';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Grid from '@mui/material/Grid';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Link from '@mui/material/Link';
import Modal from '@mui/material/Modal';
import {useParams} from 'react-router-dom';

import axios from 'axios';
import { Stack } from "@mui/material";

// const baseURL = "http://localhost/rest";
const baseURL = "https://event.janeks.de/rest";
// const baseURL = "https://game.janeks.de/rest";

const style = {
  position: 'absolute',
  top: '50%',
  left: '40%',
  transform: 'translate(-50%, -50%)',
  width: 250,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  m: 4,
  p: 4,
};

const comeState = {
  0: "NA",
  1: "No",
  2: "Maybe",
  3: "Yes",
};


let lastGuestID = 0;
let newGuestName = "";

function updateGuestName(val) {
  newGuestName = val;
}

const initialGuests = [
  // { id: 0, name: "Max", targetOf: 0, solved: 0, inQueue: 0},
];

const columns = [
  
  { field: 'name', headerName: 'Name', width: 120 },
  {
    field: 'targetOf',
    headerName: 'Target of',
    type: 'number',
    width: 70,
  },
  {
    field: 'img_count',
    headerName: 'Images',
    type: 'number',
    width: 70,
  },
  {
    field: 'solved',
    headerName: 'Solved',
    type: 'number',
    width: 70,
  },
  {
    field: 'inQueue',
    headerName: 'In queue',
    type: 'number',
    width: 70,
  },
  {
    field: 'away',
    headerName: 'Away',
    type: 'number',
    width: 70,
  },
  {
    field: 'come_state',
    headerName: 'Comes',
    type: 'string',
    width: 70,
  },
  {
    field: 'plus_one',
    headerName: '1+',
    type: 'string',
    width: 70,
  },
  {
    field: 'plus_one_en',
    headerName: '1+ en',
    type: 'number',
    width: 70,
  },
  {
    field: 'invited',
    headerName: 'Invited',
    type: 'number',
    width: 70,
  },
  {
    field: 'q_1',
    headerName: 'Bar',
    // type: 'string',
    width: 70,
  },
  {
    field: 'q_2',
    headerName: 'PizzaT',
    type: 'string',
    // width: 70,
  },
  {
    field: 'note',
    headerName: 'Note',
    type: 'string',
    // width: 70,
  },
  {
    field: 'to_bring',
    headerName: 'Brings',
    type: 'string',
    // width: 70,
  },
  { field: 'id', headerName: 'ID', width: 70 },
];

const ACTIONS = {
  ADD: 'add',
  REMOVE: 'remove',
  CLEAR: 'clear',
  UPDT_VALS: 'updt_vals',
}


function reducer(state, action) {
  switch (action.type) {
    case ACTIONS.ADD:
      return [...state, newGuest(action.data)]
      break;
    case ACTIONS.REMOVE:
      return state.filter((stat) => stat.node !== action.pl.node);
      break;
    case ACTIONS.CLEAR:
        return [];
        break;
    case ACTIONS.UPDT_VALS:
      return state.map((stat) => {
        if (stat.colNode === action.pl.node) {
          let valKeys = Object.keys(action.vals);
          for (let i in valKeys) {
            if (stat.colType == valKeys[i]) {
              return {...stat, colValue: action.vals[valKeys[i]] };
            }    
          }
          return stat;
        } else {
          return stat;
        }
      });
      break;
    default:
      return state
  }

}

function newGuest(guest) {
  return {
    id: guest['id'], name: guest['name'], img_count: guest['img_count'], targetOf: guest['target_of'], 
    solved: guest['solved'], inQueue: guest['img_requested'], away: guest['away'], come_state: comeState[guest['come_state']], 
    plus_one: guest['plus_one'], plus_one_en: guest['plus_one_en'], invited: guest['invited'], 
    q_1: guest['q_1'], q_2: guest['q_2'], note: guest['note'], to_bring: guest['tb_description']
  }
}


export default function Admin() {
  const { userId, mode } = useParams();
  const [guests, updateGuests] = useReducer(reducer, initialGuests);

  const [link, setLink] = useState('');
  const [base64Link, setBase64] = useState('');
  const [requestResponseText, setRequestResponseText] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    loadGuests();
  }
  const [invite_status, setInviteStatus] = useState('');
  const [guestName, setGuestName] = useState('');
  const [plus_one_en, setPlusOneEn] = useState(0);
  const [invited, setInvited] = useState(0);
  const [enableAdjust, setEnableAdjust] = useState(false);
  const [guestNote, setGuestNote] = useState('');

  function loadGuests() {
    updateGuests({type: ACTIONS.CLEAR});
    axios
    .post(baseURL+"/app/guesttable", {
      auth: mode,
    })
    .then((response) => {
      // console.log(response.data);
      updateGuests({type: ACTIONS.CLEAR});
      response.data.map(guest => {
        updateGuests({type: ACTIONS.ADD, data: guest});
      })
    });

    axios
    .post(baseURL+"/invitation/status", {
      auth: mode,
    })
    .then((response) => {
      setInviteStatus(response.data['accepted'] + '+' + response.data['pending'] + '/' + response.data['invite_cnt']);
    });
  }

  React.useEffect(() => {
    // Runs after the first render() lifecycle
    console.log("Admin mounted");
    loadGuests();
  }, []);

  function newGuest() {
    console.log(newGuestName);
    axios
      .post(baseURL+"/create", {
        name: newGuestName,
        auth: mode,
      })
      .then((response) => {
        console.log(response.data);
        let img = response.data['linkimage'];
        setLink(response.data['link']);
        lastGuestID = response.data['guest_id']
        setBase64(img.split('\'')[1]);
        setOpen(true);
        loadGuests();
      });
  }

  function updateEditor(data) {
    setLink(data['link']);
    setBase64(data['linkimage'].split('\'')[1])
    setPlusOneEn(data['plus_one_en']);
    setInvited(data['invited']);
    setGuestName(data['name']);
    setGuestNote(data['note'] || '');
  }

  function openGuestEditor(guestID) {
    lastGuestID = guestID;
    setOpen(true);
    axios
    .get(
      baseURL+"/guest/"+guestID
    )
    .then((response) =>
      updateEditor(response.data)      
    );
  }

  function reopenGuestPrompt() {
    console.log(lastGuestID);
    axios
    .get(
      baseURL+"/app/reopenguestprompt/"+lastGuestID
    )
    .then((response) =>
      // console.log(response.data)
      loadGuests()     
    );
  }

  function reassignPartner() {
    axios
    .get(
      baseURL+"/app/reassignpartner/"+lastGuestID
    )
    .then((response) =>
      loadGuests()
      // console.log(response.data)      
    );
  }

  function setGuestPresence(present) {
    axios
    .get(
      baseURL+"/app/guestpresent", {
        params: {
          guestID: lastGuestID,
          present: present
        },
      })
    .then((response) =>
      loadGuests()
      // console.log(response.data)      
    );
  }

  function setGuestInvited(invited) {
    axios
    .get(
      baseURL+"/app/guestinvited", {
        params: {
          guestID: lastGuestID,
          invited: invited
        },
      })
    .then((response) =>
      loadGuests()
    );
  }
  function setGuestPlusOneEn(plus_one_en) {
    axios
    .get(
      baseURL+"/app/guestenplusone", {
        params: {
          guestID: lastGuestID,
          plus_one_en: plus_one_en
        },
      })
    .then((response) =>
      loadGuests()
    );
  }

  function updateGuestNote(guestNote) {
    axios
    .post(
      baseURL+"/app/guestnote", {
        guestID: lastGuestID,
        note: guestNote
      });
  }

  function shufflePartners() {
    axios
    .get(
      baseURL+"/app/shufflepartners")
    .then((response) => {
        if (response.data == 'success') {
          loadGuests();
        } else {
          setRequestResponseText(response.data['info']);
          setOpen(true);
        }
      }
    );
  }

  function setGuestPresent() {
    setGuestPresence(0);
  }

  function setGuestAway() {
    setGuestPresence(1);
  }

  return (
    <Box sx={{ }}>
      <Grid container spacing={2} justifyContent="center" alignItems="center" sx={{mb: 1.5}}>
        <Grid item sx={{width: '60%'}}>
          <TextField
          id="outlined-number"
          label="Name"
          type="text"
          // value={guestName}
          onChange={(e) => 
            updateGuestName (
              e.target.value
            )}
          InputLabelProps={{
            shrink: true,
          }}
          // onKeyDown={(e) => handleValueKeyDown(e, node.id, 'apwr')}
        />
        </Grid>
        <Grid item>
          <Button variant="contained" onClick={newGuest}>New guest</Button>
        </Grid>
      </Grid>

      <Box style={{ height: 800, width: '100%' }}>
        <DataGrid
          rows={guests}
          columns={columns}
          pageSize={15}
          rowsPerPageOptions={[15]}
          // checkboxSelection
          disableSelectionOnClick
          onRowClick={(e) => 
            openGuestEditor(e.row.id)
          }
        />
      </Box>

      <Grid container spacing={2} justifyContent="center" alignItems="center" sx={{mt: 1.5}}>
        {enableAdjust && <Typography style={{color: "gray", marginRight: 5}}>{invite_status}</Typography>}
        <Button variant="contained" onClick={shufflePartners}>Shuffle partners</Button>
      </Grid>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <img src={`data:image/jpeg;charset=utf-8;base64,${base64Link}`} width="100%"/>
          {/* <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Lol{requestResponseText}
          </Typography> */}
          <Link href={link} underline="none">{link}</Link>
          <Stack spacing={2} direction="row" sx={{mt: 1}}>
          <FormControlLabel control={<Switch 
                checked={enableAdjust} 
                onChange={(e) => {
                  setEnableAdjust(e.target.checked);
                }}
                />} label="Config"/>
                {enableAdjust && <Typography style={{color: "gray"}}>{guestName}</Typography>}
          </Stack>
          {/* <ContentCopyIcon onClick={() => {navigator.clipboard.writeText("lol")}}></ContentCopyIcon> */}
          {enableAdjust &&
          <Grid container spacing={1} justifyContent="center" alignItems="center" sx={{mt: 1}}>
            <Grid item>
            <Button variant="contained" onClick={reopenGuestPrompt}>Reopen prompt</Button>
            </Grid>
            <Grid item>
            <Button variant="contained" onClick={reassignPartner}>Reassign partner</Button>
            </Grid>
            <Grid item>
            <ButtonGroup variant="contained" aria-label="outlined primary button group">
              <Button onClick={setGuestPresent}>Present</Button>
              <Button onClick={setGuestAway}>Away</Button>
            </ButtonGroup>
            </Grid>
            <Grid item>
              <FormControlLabel control={<Switch 
                checked={plus_one_en} 
                onChange={(e) => {
                  setPlusOneEn(e.target.checked);
                  setGuestPlusOneEn(e.target.checked ? 1 : 0)
                }}
                />} label="1+ en"/>
              <FormControlLabel control={<Switch 
                checked={invited} 
                onChange={(e) => {
                  setInvited(e.target.checked);
                  setGuestInvited(e.target.checked ? 1 : 0)
                }}
                />} label="Invited"/>
            </Grid>
            <Grid item>
              <TextField id="standard-basic" 
                    label="Note" 
                    variant="standard"  
                    sx={{margin: 1}}
                    onChange={(e) => {
                      setGuestNote(e.target.value);
                      updateGuestNote(e.target.value)
                    }}
                    value={guestNote}/>
            </Grid>
          </Grid>}
        </Box>
      </Modal>
    </Box>
  );
}
